import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { Button } from './Button';
export function Footer() {
  return <footer className="w-full bg-black text-white py-16 px-4" data-id="element-76">
      <div className="max-w-7xl mx-auto" data-id="element-77">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-12" data-id="element-78">
          {/* Brand Column */}
          <div data-id="element-79">
            <Link to="/" className="inline-block mb-6" data-id="element-80">
              <img src="https://cdn.magicpatterns.com/uploads/ghb8oGu2AFpSGCwhCKzLpD/White_logo.png" alt="EquityRich" className="h-10 w-auto" data-id="element-81" />
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-82">
              EquityRich.ca is a Canadian entity, operating as a referral
              institution. Mortgage Agents and Brokers represent Everything
              Mortgages (FSRA #12755)
            </p>
            <Button variant="primary" size="md" href="/#form" data-id="element-83">
              Find Out How Much You Can Borrow
            </Button>
          </div>

          {/* Services Column */}
          <div data-id="element-84">
            <h3 className="text-lg mb-6 font-[500]" data-id="element-85">SERVICES</h3>
            <ul className="space-y-3" role="list" data-id="element-86">
              <li data-id="element-87">
                <Link to="/services/home-equity-loans" className="text-gray-400 hover:text-accent transition-colors" data-id="element-88">
                  First Mortgages
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/services/second-mortgages" className="text-gray-400 hover:text-accent transition-colors" data-id="element-90">
                  Second Mortgages
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/services/heloc" className="text-gray-400 hover:text-accent transition-colors" data-id="element-92">
                  Equity Lending
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/services" className="text-gray-400 hover:text-accent transition-colors" data-id="element-94">
                  Debt Consolidation
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links Column */}

          {/* Locations Column */}
          <div data-id="element-95">
            <h3 className="text-lg mb-6 font-[500]" data-id="element-96">LOCATIONS</h3>
            <ul className="space-y-3" role="list" data-id="element-97">
              <li data-id="element-98">
                <Link to="/locations/toronto" className="text-gray-400 hover:text-accent transition-colors" data-id="element-99">
                  Toronto
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/locations/mississauga" className="text-gray-400 hover:text-accent transition-colors" data-id="element-101">
                  Mississauga
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/locations/brampton" className="text-gray-400 hover:text-accent transition-colors" data-id="element-103">
                  Brampton
                </Link>
              </li>
              <li data-id="element-104">
                <Link to="/locations/markham" className="text-gray-400 hover:text-accent transition-colors" data-id="element-105">
                  Markham
                </Link>
              </li>
              <li data-id="element-106">
                <Link to="/locations/vaughan" className="text-gray-400 hover:text-accent transition-colors" data-id="element-107">
                  Vaughan
                </Link>
              </li>
              <li data-id="element-108">
                <Link to="/locations/richmond-hill" className="text-gray-400 hover:text-accent transition-colors" data-id="element-109">
                  Richmond Hill
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/locations/oakville" className="text-gray-400 hover:text-accent transition-colors" data-id="element-111">
                  Oakville
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/locations/burlington" className="text-gray-400 hover:text-accent transition-colors" data-id="element-113">
                  Burlington
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-114">
            <h3 className="text-lg mb-6 font-[500]" data-id="element-115">CONTACT</h3>
            <ul className="space-y-4" role="list" data-id="element-116">
              <li className="flex items-start" data-id="element-117">
                <PhoneIcon className="h-5 w-5 mr-3 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-118" />
                <div data-id="element-119">
                  <p className="text-sm font-medium mb-1" data-id="element-120">Phone</p>
                  <a href="tel:+16476679957" className="text-gray-400 hover:text-accent transition-colors" data-id="element-121">
                    +1-647-667-9957
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-122">
                <MailIcon className="h-5 w-5 mr-3 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-123" />
                <div data-id="element-124">
                  <p className="text-sm font-medium mb-1" data-id="element-125">Email</p>
                  <a href="mailto:info@equityrich.ca" className="text-gray-400 hover:text-accent transition-colors" data-id="element-126">
                    info@equityrich.ca
                  </a>
                </div>
              </li>
              <li className="flex items-start" data-id="element-127">
                <MapPinIcon className="h-5 w-5 mr-3 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-128" />
                <div data-id="element-129">
                  <p className="text-sm font-medium mb-1" data-id="element-130">Office</p>
                  <p className="text-gray-400" data-id="element-131">
                    18 Wynford Dr, Suite 307, Toronto, ON, M3C 3S2
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center" data-id="element-132">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-133">
            Copyright © 2026 Equity Rich. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-134">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors" aria-label="Facebook" data-id="element-135">
              <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" aria-hidden="true" data-id="element-136">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-137" />
              </svg>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors" aria-label="LinkedIn" data-id="element-138">
              <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" aria-hidden="true" data-id="element-139">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-140" />
              </svg>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors" aria-label="Instagram" data-id="element-141">
              <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" aria-hidden="true" data-id="element-142">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z" data-id="element-143" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>;
}